

import './Header.scss';

import MenuLeft from './MenuLeft/MenuLeft';
import MenuRight from './MenuRight/MenuRight';


const Header = (props) => {
    const {dispatch} = props;



        return (
            <div className="Header">
                <MenuLeft 
                dispatch={dispatch}
                />
                <MenuRight  adminViewChange={props.adminViewChange}
                            userRole={props.userRole}
                            dispatch={dispatch}
                />
            </div>
        )
    }
export default  Header;